import {
  clearCachedExtensionTokens,
  msalInstance,
  useAuthStore,
} from '@sib/auth';

export const handleLogout = async () => {
  useAuthStore.getState().setAccount(null);
  clearCachedExtensionTokens();
  await msalInstance.clearCache();
};
